import { Mapper } from 'planning-portal-library/src/lib/core/base';
import {
  MasterPlanLocation,
} from 'planning-portal-library/src/lib/core/domain';
import {
  MasterPlanLocationWebEntity,
} from './master-plan-location-web-entity';

export class MasterPlanLocationWebRespositoryMapper extends Mapper<
  MasterPlanLocationWebEntity,
  MasterPlanLocation
> {
  mapFrom(param: MasterPlanLocationWebEntity): MasterPlanLocation {
    return {
      id: param.id,
      locationId: param.locationId,
      name: param.name,
      latitude: param.latitude,
      longitude: param.longitude,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      locationType: param.locationType,
      planContainerId: param.planContainerId,
      segment: param.segment,
      stopTime :param.stopTime,
      productsAdditionalInfo: param.productsAdditionalInfo?.map((product) => ({
        productId: product.productId,
        productName: product.productName,
        productAdditionalInfo: product.productAdditionalInfo,
        daoLocationKey: product.daoLocationKey,
        productKeyMapping: product.productKeyMapping,
      })),
    };
  }

  mapTo(param: MasterPlanLocation): MasterPlanLocationWebEntity {
    return {
      id: param.id,
      locationId: param.locationId,
      name: param.name,
      latitude: param.latitude,
      longitude: param.longitude,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      locationType: param.locationType,
      planContainerId: param.planContainerId,
      segment: param.segment,
      stopTime: param.stopTime,
      productsAdditionalInfo: param.productsAdditionalInfo?.map((product) => ({
        productId: product.productId,
        productName: product.productName,
        productAdditionalInfo: product.productAdditionalInfo,
        daoLocationKey: product.daoLocationKey,
        productKeyMapping: product.productKeyMapping,
      })),
    };
  }
}
